import { useQuery } from "@tanstack/react-query";

import { enterCustomerQuote } from "../repo";

/** 按 URL 中精确核价版本 ID 进入对客报价。 */
export function useCustomerQuoteEntryRedirect(budgetOrderId: string | undefined) {
  return useQuery({
    queryKey: ["customerQuoteEnter", budgetOrderId],
    queryFn: () => enterCustomerQuote(budgetOrderId as string),
    enabled: Boolean(budgetOrderId),
    retry: false,
  });
}
